import { createContext, useContext } from 'react';

import { MessagePayload, MessageType } from './types';

interface RealTimeContextData {
  loading: {
    up: () => void;
    down: () => void;
  };

  unregisterHandler: (type: MessageType, id: string) => void;

  registerHandler: (type: MessageType, handler: (payload: MessagePayload) => void) => string;

  setUserId: (id: string | null) => void;
}

export const RealTimeContext = createContext<RealTimeContextData>({} as RealTimeContextData);

export function useRealTime(): RealTimeContextData {
  const context = useContext(RealTimeContext);

  if (!context.loading) {
    throw new Error('useRealTime must be used within a RealTimeProvider');
  }

  return context;
}
